<template>
  <!-- 自我评价组件 -->
  <!-- ApplyForAJob等于1时正常显示数据 不等于1时显示自我评价编辑栏 -->
  <div :class="ApplyForAJob == 1 ? 'normal' : 'editor'">
    <!-- 正常显示 自我评价数据 -->
    <div v-if="ApplyForAJob == 1" class="NormalDisplay">
      <!-- 没有数据显示待添加 -->
      <div
        class="None firm-clickable"
        v-if="data == '' || data == null"
        @click="handelClickEDITOR"
      >
        待添加
      </div>
      <!-- 有数据正常展示 -->
      <!-- <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        {{ item.data }}
      </div> -->
      <div class="normal-show" v-else>
        {{ data }}
      </div>
    </div>
    <!-- 展示自我评价编辑栏 -->
    <div v-if="ApplyForAJob == 2" class="StartEditing">
      <div class="EDITOR-top">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="EDITOR-top-title">
            <p>自我评价：</p>
            <div class="firm-clickable" @click="handelDele"></div>
          </div>
          <el-form-item prop="textarea">
            <div class="EDITOR-top-ipt">
              <el-input
                type="textarea"
                placeholder="请简明描述您的职业优势，对自己职业评价，让用人单位快速了解您！为了保护好个人隐私，请不要填写手机号、QQ、微信等联系方式"
                v-model="ruleForm.textarea"
                maxlength="300"
                minlength="12"
                show-word-limit
                resize="none"
                :autosize="true"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  updateUserResumes, // 修改简历
} from "../../../../../../assets/api/CenterJane";
export default {
  // 接收父组件传递的参数
  props: {
    ApplyForAJob: {},
    data: {},
  },
  data() {
    return {
      ruleForm: {
        textarea: "", // 自我评价输入框
      }, // 选择框数据
      rules: {
        textarea: [
          {
            required: true,
            min: 12,
            message: "请输入至少12字的自我评价！",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
    };
  },
  watch: {
    // 监听
    ApplyForAJob: {
      handler(newSs, old) {
        this.ruleForm.textarea = this.data;
      },
    },
  },
  methods: {
    // 点击待添加
    handelClickEDITOR() {
      this.$emit("handelClickEDITOR", 3);
    },
    // 清除自我评价
    handelDele() {
      this.$confirmWithScroll("是否清除自我评价?", "提示").then(() => {
        var data = {
          data: {
            userId: this.$store.getters.getUser.id,
            selfEval: "",
          },
        };
        updateUserResumes(data).then((res) => {
          if (res.code == 0) {
            this.ruleForm.textarea = "";
            this.$emit("handelSubmitEdit", 3);
            this.$tool.PromptBox("success", "修改成功");
          }
        });
      }).catch(() => {});
    },
    // 取消编辑
    handelUnEdit() {
      this.ruleForm.textarea = "";
      this.$emit("handelUnEdit", 3);
    },
    // 编辑提交
    handelSubmitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            data: {
              userId: this.$store.getters.getUser.id,
              selfEval: this.ruleForm.textarea,
            },
          };

          // 调用接口修改简历个人信息
          updateUserResumes(data).then((res) => {
            if (res.code == 0) {
              this.ruleForm.textarea = "";
              this.$emit("handelSubmitEdit", 3);
              this.$tool.PromptBox("success", "修改成功");
            } else {
              // 失败
              // this.$tool.PromptBox("error", res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// 自我评价输入框的样式
/deep/.el-textarea {
  min-height: 80px !important;
}
/deep/.el-textarea__inner {
  min-height: 80px !important;
}
// 正常显示
.normal {
  width: 100%;
  min-height: 25px;
}
// 显示编辑栏
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
}

// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据显示待添加
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  // 有数据正常展示
  .normal-show {
    width: 900px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    overflow-wrap: break-word;
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  .EDITOR-top {
    width: 100%;
    margin-bottom: 20px;
    .EDITOR-top-title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      p {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
      div {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
        background-size: 100% 100%;
      }
    }
    .EDITOR-top-ipt {
      width: 100%;
      min-height: 80px;
      line-height: 0px;
    }
  }
  // 编辑栏下方按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
